(function () {
  var el = document.getElementById('tv-consent');
  if (!el) return;

  var DONE_KEY = 'trivelle:consent-done';
  var mainView = el.querySelector('[data-tv-consent-main]');
  var prefsView = el.querySelector('[data-tv-consent-prefs]');
  var regionOnly = el.getAttribute('data-region-only') === 'true';
  var api = null;

  var lastH = -1;
  function publishHeight() {
    var h = el.hidden ? 0 : el.offsetHeight;
    if (h === lastH) return;
    lastH = h;
    try { document.documentElement.style.setProperty('--tv-consent-h', h + 'px'); } catch (e) {}
  }
  if (window.ResizeObserver) {
    try { new ResizeObserver(publishHeight).observe(el); } catch (e) {}
  }
  window.addEventListener('resize', publishHeight);

  function markDone() {
    try { localStorage.setItem(DONE_KEY, '1'); } catch (e) { }
  }
  function hasDecided() {
    try { if (localStorage.getItem(DONE_KEY)) return true; } catch (e) { }
    if (api && api.currentVisitorConsent) {
      var c = api.currentVisitorConsent() || {};
      if (c.marketing || c.analytics || c.preferences) return true;
    }
    return false;
  }

  function show(showPrefs) {
    el.hidden = false;
    if (mainView) mainView.hidden = !!showPrefs;
    if (prefsView) prefsView.hidden = !showPrefs;
    var view = showPrefs ? prefsView : mainView;
    var first = view && view.querySelector('button, input:not([disabled])');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    publishHeight();
  }
  function hide() { el.hidden = true; publishHeight(); }

  function syncToggles() {
    if (!api || !api.currentVisitorConsent) return;
    var c = api.currentVisitorConsent() || {};
    var inputs = el.querySelectorAll('[data-tv-pref]');
    for (var i = 0; i < inputs.length; i++) {
      var key = inputs[i].getAttribute('data-tv-pref');
      inputs[i].checked = c[key] === 'yes';
    }
  }

  function setConsent(consent) {
    markDone();
    try { document.dispatchEvent(new CustomEvent('trivelle:consent-decided')); } catch (e) {}
    if (api && api.setTrackingConsent) {
      api.setTrackingConsent(consent, function () { hide(); });
    } else {
      hide();
    }
  }

  el.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tv-consent]');
    if (!btn) return;
    var action = btn.getAttribute('data-tv-consent');
    if (action === 'accept') {
      setConsent({ marketing: true, analytics: true, preferences: true, sale_of_data: true });
    } else if (action === 'decline') {
      setConsent({ marketing: false, analytics: false, preferences: false, sale_of_data: false });
    } else if (action === 'prefs') {
      syncToggles();
      show(true);
    } else if (action === 'back') {
      show(false);
    }
  });

  if (prefsView) {
    prefsView.addEventListener('submit', function (e) {
      e.preventDefault();
      var consent = {};
      var inputs = el.querySelectorAll('[data-tv-pref]');
      for (var i = 0; i < inputs.length; i++) {
        consent[inputs[i].getAttribute('data-tv-pref')] = inputs[i].checked;
      }
      consent.sale_of_data = consent.marketing === true;
      setConsent(consent);
    });
  }

  document.addEventListener('trivelle:open-consent', function () {
    syncToggles();
    show(true);
  });

  if (!window.Shopify || !window.Shopify.loadFeatures) return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error) return;
    api = window.Shopify.customerPrivacy;
    if (!api) return;
    var required = typeof api.shouldShowBanner === 'function' && api.shouldShowBanner();
    if (required || (!regionOnly && !hasDecided())) {
      show(false);
    }
  });
})();
